import { messages } from "common/data"
import { SIGNUP_REQUEST, SIGNUP_SUCCESS, SIGNUP_FAILURE } from "./actionTypes"

const initialState = {
  message: "", //store message here
  loading: false,
  user: null,
  error: null,
}

const registerReducer = (state = initialState, action) => {
  // console.log("Dispatched action:", action) // Debugging log
  //authreducer takes to value (state,action)

  switch (action.type) {
    case SIGNUP_REQUEST:
      return { ...state, loading: true, error: null, message: "" }
    case SIGNUP_SUCCESS:
      console.log("User updated:", action.payload.user) // Debugging log
      return {
        ...state,
        loading: false,
        user: action.payload.user, // Correctly assigning user
        message: action.payload?.message,
      }
    case SIGNUP_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload, // Already a string message
        message: action.payload, // Keep message format consistent
      }

    default:
      return state
  }
}

export default registerReducer
